const placeholderContent = (viewPhone) => {
  if (!viewPhone) {
    return "Compose message";
  }
  const messageable = !viewPhone?.smsUnsubscribed;
  return messageable ? "Compose message" : viewPhone.smsIcon.tooltipText;
};

export default placeholderContent;
